// extracted by mini-css-extract-plugin
module.exports = {"mainUiBlock":"_1Slzl","tooltipContainerWrapper":"_1Rph5"};